import { get } from 'lodash';

export const featureEnabled = (config, path, customer, customers) =>
  get(config, path) || (customers && customers.includes(customer));
